import styled from "styled-components";

export const InputWrapper = styled.div<{
  width?: string;
  height?: string;
}>`
  gap: 0.5rem;
  min-height: ${(props) => props.height ?? "3rem"};
  border-radius: 0.25rem;
  width: ${(props) => props.width ?? "100%"};
  max-width: 30rem;
  display: flex;
  background-color: #fff;
  border: 1px solid #cccccc;
  position: relative;
  box-sizing: content-box;
  align-items: center;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const InputElement = styled.input<{
  height?: string;
}>`
  width: 100%;
  min-height: ${(props) => props.height ?? "3rem"};
  border-radius: 0.25rem;
  padding-left: 1rem;
  outline: none;
  border: none;
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.5rem;
`;

export const TextWrapper = styled.div`
  position: absolute;
  top: -0.5rem;
  left: 0.75rem;
  padding-left: 0.25rem;
  padding-right: 0.25rem;
  background-color: #fff;
`;

export const ErrorWrapper = styled.div`
  padding-left: 1rem;
`;
